export const ESPN_HERO_LIGUE1_PLAYER_IMAGES: Record<string, Record<string, string[]>> = {
  angers: {
    'belkhdim-yassin': ['belkhdim-yassin-001.png'],
    'cherif-sidiki': [
      'cherif-sidiki-001.png',
      'cherif-sidiki-002.png',
      'cherif-sidiki-003.png',
      'cherif-sidiki-004.png'
    ],
    'himad-abdelli': ['himad-abdelli-001.png', 'himad-abdelli-002.png', 'himad-abdelli-003.png'],
    'ousmane-camara': ['ousmane-camara-001.png']
  },
  'as-monaco': {
    'ansu-fati': ['ansu-fati-001.png', 'ansu-fati-002.png', 'ansu-fati-003.png'],
    'denis-zakaria': ['denis-zakaria-001.png', 'denis-zakaria-002.png', 'denis-zakaria-003.png'],
    'folarin-balogun': ['folarin-balogun-001.png'],
    'golovin-aleksandr': [
      'golovin-aleksandr-001.png',
      'golovin-aleksandr-002.png',
      'golovin-aleksandr-003.png',
      'golovin-aleksandr-004.png'
    ],
    'minamino-takumi': ['minamino-takumi-001.png', 'minamino-takumi-002.png'],
    'paul-pogba': [
      'paul-pogba-001.png',
      'paul-pogba-002.png',
      'paul-pogba-003.png',
      'paul-pogba-004.png',
      'paul-pogba-005.png',
      'paul-pogba-006.png',
      'paul-pogba-007.png'
    ]
  },
  auxerre: {
    'danny-namaso': ['danny-namaso-001.png', 'danny-namaso-002.png', 'danny-namaso-003.png'],
    'diomande-sinaly': [
      'diomande-sinaly-001.png',
      'diomande-sinaly-002.png',
      'diomande-sinaly-003.png',
      'diomande-sinaly-004.png',
      'diomande-sinaly-005.png'
    ],
    'francisco-sierralta': [
      'francisco-sierralta-001.png',
      'francisco-sierralta-002.png',
      'francisco-sierralta-003.png',
      'francisco-sierralta-004.png'
    ],
    'lassine-sinayoko': [
      'lassine-sinayoko-001.png',
      'lassine-sinayoko-002.png',
      'lassine-sinayoko-003.png',
      'lassine-sinayoko-004.png'
    ]
  },
  brest: {
    'kamory-doumbia': [
      'kamory-doumbia-001.png',
      'kamory-doumbia-002.png',
      'kamory-doumbia-003.png',
      'kamory-doumbia-004.png'
    ],
    'lala-kenny': ['lala-kenny-001.png', 'lala-kenny-002.png', 'lala-kenny-003.png', 'lala-kenny-004.png'],
    'romain-del-castillo': [
      'romain-del-castillo-001.png',
      'romain-del-castillo-002.png',
      'romain-del-castillo-003.png',
      'romain-del-castillo-004.png'
    ]
  },
  'le-havre': {
    'issa-soumare': [
      'issa-soumare-001.png',
      'issa-soumare-002.png',
      'issa-soumare-003.png',
      'issa-soumare-004.png',
      'issa-soumare-005.png'
    ],
    'rassoul-ndiaye': [
      'rassoul-ndiaye-001.png',
      'rassoul-ndiaye-002.png',
      'rassoul-ndiaye-003.png',
      'rassoul-ndiaye-004.png'
    ],
    'yassine-ketcha': ['yassine-ketcha-001.png', 'yassine-ketcha-002.png', 'yassine-ketcha-003.png']
  },
  lens: {
    'deiver-machado': ['deiver-machado-001.png', 'deiver-machado-002.png'],
    'malang-sarr': ['malang-sarr-001.png', 'malang-sarr-002.png', 'malang-sarr-003.png', 'malang-sarr-004.png'],
    'mamadou-sangare': [
      'mamadou-sangare-001.png',
      'mamadou-sangare-002.png',
      'mamadou-sangare-003.png',
      'mamadou-sangare-004.png',
      'mamadou-sangare-005.png'
    ],
    'odsonne-edouard': [
      'odsonne-edouard-001.png',
      'odsonne-edouard-002.png',
      'odsonne-edouard-003.png',
      'odsonne-edouard-004.png'
    ],
    thauvin: [
      'thauvin-001.png',
      'thauvin-002.png',
      'thauvin-003.png',
      'thauvin-004.png',
      'thauvin-005.png',
      'thauvin-006.png'
    ]
  },
  lille: {
    bentaleb: ['bentaleb-001.png'],
    'ethan-mbappe': [
      'ethan-mbappe-001.png',
      'ethan-mbappe-002.png',
      'ethan-mbappe-003.png',
      'ethan-mbappe-004.png',
      'ethan-mbappe-005.png'
    ],
    giroud: ['giroud-001.png', 'giroud-002.png'],
    'hakon-haraldsson': [
      'hakon-haraldsson-001.png',
      'hakon-haraldsson-002.png',
      'hakon-haraldsson-003.png',
      'hakon-haraldsson-004.png',
      'hakon-haraldsson-005.png'
    ],
    meunier: ['meunier-001.png']
  },
  lorient: {
    'aiyegun-tosin': [
      'aiyegun-tosin-001.png',
      'aiyegun-tosin-002.png',
      'aiyegun-tosin-003.png',
      'aiyegun-tosin-004.png'
    ],
    'igor-silva': [
      'igor-silva-001.png',
      'igor-silva-002.png',
      'igor-silva-003.png',
      'igor-silva-004.png',
      'igor-silva-005.png'
    ],
    'pablo-pagis': ['pablo-pagis-001.png', 'pablo-pagis-002.png', 'pablo-pagis-003.png'],
    'sambou-soumano': ['sambou-soumano-001.png', 'sambou-soumano-002.png', 'sambou-soumano-003.png']
  },
  lyon: {
    fofana: ['fofana-001.png', 'fofana-002.png', 'fofana-003.png', 'fofana-004.png', 'fofana-005.png'],
    ghezzal: ['ghezzal-001.png', 'ghezzal-002.png', 'ghezzal-003.png'],
    tagliafico: ['tagliafico-001.png', 'tagliafico-002.png', 'tagliafico-003.png'],
    tolisso: ['tolisso-001.png', 'tolisso-002.png']
  },
  metz: {
    'cheikh-sabaly': [
      'cheikh-sabaly-001.png',
      'cheikh-sabaly-002.png',
      'cheikh-sabaly-003.png',
      'cheikh-sabaly-004.png'
    ],
    'gauthier-hein': [
      'gauthier-hein-001.png',
      'gauthier-hein-002.png',
      'gauthier-hein-003.png',
      'gauthier-hein-004.png'
    ],
    'giorgi-tsitaishvili': [
      'giorgi-tsitaishvili-001.png',
      'giorgi-tsitaishvili-002.png',
      'giorgi-tsitaishvili-003.png',
      'giorgi-tsitaishvili-004.png'
    ],
    'habib-diallo': ['habib-diallo-001.png', 'habib-diallo-002.png', 'habib-diallo-003.png', 'habib-diallo-004.png']
  },
  nantes: {
    'johann-lepenant': [
      'johann-lepenant-001.png',
      'johann-lepenant-002.png',
      'johann-lepenant-003.png',
      'johann-lepenant-004.png'
    ],
    'matthis-abline': [
      'matthis-abline-001.png',
      'matthis-abline-002.png',
      'matthis-abline-003.png',
      'matthis-abline-004.png'
    ],
    'mostafa-abdalla': [
      'mostafa-abdalla-001.png',
      'mostafa-abdalla-002.png',
      'mostafa-abdalla-003.png',
      'mostafa-abdalla-004.png'
    ]
  },
  niza: {
    'costa-santos-dante': ['costa-santos-dante-001.png', 'costa-santos-dante-002.png', 'costa-santos-dante-003.png'],
    'jeremie-boga': ['jeremie-boga-001.png', 'jeremie-boga-002.png', 'jeremie-boga-003.png', 'jeremie-boga-004.png'],
    'jonathan-clauss': [
      'jonathan-clauss-001.png',
      'jonathan-clauss-002.png',
      'jonathan-clauss-003.png',
      'jonathan-clauss-004.png',
      'jonathan-clauss-005.png'
    ],
    'morgan-sanson': [
      'morgan-sanson-001.png',
      'morgan-sanson-002.png',
      'morgan-sanson-003.png',
      'morgan-sanson-004.png',
      'morgan-sanson-005.png',
      'morgan-sanson-006.png'
    ],
    'sofiane-diop': ['sofiane-diop-001.png', 'sofiane-diop-002.png', 'sofiane-diop-003.png', 'sofiane-diop-004.png']
  },
  'o-marseille': {
    aubameyang: ['aubameyang-001.png', 'aubameyang-002.png'],
    balerdi: ['balerdi-001.png', 'balerdi-002.png', 'balerdi-003.png'],
    hojbjerg: ['hojbjerg-001.png', 'hojbjerg-002.png', 'hojbjerg-003.png', 'hojbjerg-004.png', 'hojbjerg-005.png'],
    medina: ['medina-001.png', 'medina-002.png'],
    paixao: ['paixao-001.png', 'paixao-002.png', 'paixao-003.png'],
    weah: ['weah-001.png', 'weah-002.png', 'weah-003.png', 'weah-004.png']
  },
  'paris-fc': {
    'ilan-kebbal': ['ilan-kebbal-001.png', 'ilan-kebbal-002.png', 'ilan-kebbal-003.png', 'ilan-kebbal-004.png'],
    'moses-simon': ['moses-simon-001.png', 'moses-simon-002.png', 'moses-simon-003.png', 'moses-simon-004.png'],
    'otavio-da-silva': [
      'otavio-da-silva-001.png',
      'otavio-da-silva-002.png',
      'otavio-da-silva-003.png',
      'otavio-da-silva-004.png'
    ]
  },
  psg: {
    barcola: [
      'barcola-001.png',
      'barcola-002.png',
      'barcola-003.png',
      'barcola-004.png',
      'barcola-005.png',
      'barcola-006.png'
    ],
    dembele: ['dembele-001.png'],
    kvaratskhelia: ['kvaratskhelia-001.png', 'kvaratskhelia-002.png'],
    marquinhos: ['marquinhos-001.png', 'marquinhos-002.png', 'marquinhos-003.png'],
    pacho: ['pacho-001.png'],
    vitinha: ['vitinha-001.png', 'vitinha-002.png', 'vitinha-003.png', 'vitinha-004.png']
  },
  rennes: {
    'blas-ludovic': ['blas-ludovic-001.png', 'blas-ludovic-002.png', 'blas-ludovic-003.png'],
    'breel-embolo': ['breel-embolo-001.png', 'breel-embolo-002.png'],
    lepaul: ['lepaul-001.png', 'lepaul-002.png', 'lepaul-003.png'],
    'seko-fofana': ['seko-fofana-001.png', 'seko-fofana-002.png', 'seko-fofana-003.png']
  },
  strasbourg: {
    barco: ['barco-001.png', 'barco-002.png', 'barco-003.png'],
    enciso: ['enciso-001.png', 'enciso-002.png'],
    panichelli: ['panichelli-001.png', 'panichelli-002.png', 'panichelli-003.png', 'panichelli-004.png']
  },
  toulouse: {
    'cristian-casseres': [
      'cristian-casseres-001.png',
      'cristian-casseres-002.png',
      'cristian-casseres-003.png',
      'cristian-casseres-004.png'
    ],
    'emerson-da-silva': ['emerson-da-silva-001.png'],
    'frank-magri': ['frank-magri-001.png', 'frank-magri-002.png', 'frank-magri-003.png', 'frank-magri-004.png'],
    'julian-vignolo': [
      'julian-vignolo-001.png',
      'julian-vignolo-002.png',
      'julian-vignolo-003.png',
      'julian-vignolo-004.png',
      'julian-vignolo-005.png',
      'julian-vignolo-006.png'
    ],
    'santiago-hidalgo': ['santiago-hidalgo-001.png']
  }
};
